import { AddonCountdownModel } from '@/components/addons/countdown/Model';
import { AddonLfButtonModel } from '@/components/addons/lf-button/Model';
import { AddonLfIconModel } from '@/components/addons/lf-icon/Model';
import { AddonLfImageModel } from '@/components/addons/lf-image/Model';
import { GameCampaignLinkModel } from '@/components/games/campaign-link/Model';
import ColumnModel from '@/components/layout/column/ColumnModel';
import { SectionBaseModel } from '@/components/layout/section/SectionBaseModel';
import ActionsModel from '@/models/actions/ActionsModel';
import { ActionType } from '@/typings/enums/enums';
import { ModelTypes } from '@/typings/types/types';
import { SdkAddonButton } from './addons/button';
import { SdkAddonImage } from './addons/image';
import { SdkColumnModel } from './column';
import { SdkFlowPageModel } from './flowPage';

export type TriggerActionOrigin =
  | AddonLfButtonModel
  | GameCampaignLinkModel
  | AddonCountdownModel
  | AddonLfIconModel
  | undefined;

export class SdkActionModel {
  #action: ActionsModel;
  #originModel: ModelTypes;

  constructor(action: ActionsModel, origin: ModelTypes) {
    this.#action = action;
    this.#originModel = origin;
  }

  public get type(): ActionType {
    return this.#action.state.type;
  }

  public get flowPage(): number | null {
    return this.#action.state.flowPage ?? null;
  }

  public get origin() {
    if (this.#originModel instanceof SectionBaseModel) {
      return new SdkFlowPageModel(this.#originModel);
    }
    if (this.#originModel instanceof AddonLfButtonModel) {
      return new SdkAddonButton(this.#originModel);
    }
    if (this.#originModel instanceof AddonLfImageModel) {
      return new SdkAddonImage(this.#originModel);
    }
    if (this.#originModel instanceof ColumnModel) {
      return new SdkColumnModel(this.#originModel);
    }
  }
}
